import { useEffect, useState } from "react";

const useHideSidePanel = (): {
  showSidePanel: boolean;
  showAdvancedSearch: boolean;
  handleToggleAdvanceSearchPanel: () => void;
  handleToggleSidePanel: () => void;
} => {
  const [showSidePanel, setShowSidePanel] = useState(false);
  const [showAdvancedSearch, setShowAdvancedSearch] = useState(false);

  const handleKeyPress = (event: KeyboardEvent) => {
    if (event.key === "Escape") {
      if (showSidePanel) {
        setShowSidePanel(false);
      }
      if (showAdvancedSearch) {
        setShowAdvancedSearch(false);
      }
    }
  };

  const handleToggleSidePanel = () => setShowSidePanel(!showSidePanel);
  const handleToggleAdvanceSearchPanel = () =>
    setShowAdvancedSearch(!showAdvancedSearch);

  useEffect(() => {
    if (showSidePanel || showAdvancedSearch) {
      window.addEventListener("keydown", handleKeyPress);
      document.body.classList.add("background-overlay");
    } else {
      document.body.classList.remove("background-overlay");
    }

    return () => {
      window.removeEventListener("keydown", handleKeyPress);
      document.body.classList.remove("background-overlay");
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showSidePanel, showAdvancedSearch]);

  return {
    showSidePanel,
    showAdvancedSearch,
    handleToggleAdvanceSearchPanel,
    handleToggleSidePanel,
  };
};

export default useHideSidePanel;
